// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-entry-dialog-base__warning {
  margin-top: 30px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntryDialogues/EntryDialogBase/EntryDialogBase.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR","sourcesContent":[".dl-entry-dialog-base__warning {\n  margin-top: 30px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
